import { DASHBOARD } from "../lib/constants/actions";



export const getAnalytics = (data) => {
    return {
        type: DASHBOARD.GET_ANALYTICS,
        payload: data
    }
}

export const getAnalyticsSuccess = (data) => {
    return {
        type: DASHBOARD.GET_ANALYTICS_SUCCESS,
        payload: data
    }
}


export const getGoogleAnalytics = (data) => {
    return {
        type: DASHBOARD.GET_GOOGLE_ANALYTICS,
        payload: data
    }
}

export const getGoogleAnalyticsSuccess = (data) => {
    return {
        type: DASHBOARD.GET_GOOGLE_ANALYTICS_SUCCESS,
        payload: data
    }
}


export const getGoogleAnalyticsGraph = (data) => {
    return {
        type: DASHBOARD.GET_GOOGLE_ANALYTICS_GRAPH,
        payload: data
    }
}

export const getGoogleAnalyticsGraphSuccess = (data) => {
    return {
        type: DASHBOARD.GET_GOOGLE_ANALYTICS_GRAPH_SUCCESS,
        payload: data
    }
}

export const getTopSearches = (data) => {
    return {
        type: DASHBOARD.GET_TOP_SEARCHES,
        payload: data
    }
}

export const getTopSearchesSuccess = (data) => {
    return {
        type: DASHBOARD.GET_TOP_SEARCHES_SUCCESS,
        payload: data
    }
}



export const getCampaignAnalytics = (data) => {
    return { type: DASHBOARD.GET_CAMPAIGNS_ANALYTICS, payload: data }
}
export const getCampaignAnalyticsSuccess = (data) => {
    return { type: DASHBOARD.GET_CAMPAIGNS_ANALYTICS_SUCCESS, payload: data }
}

export const getTransactionsGraphData = (data) => {
    return { type: DASHBOARD.GET_TRANSACTIONS_GRAPH_DATA, payload: data }
}
export const getTransactionsGraphDataSuccess = (data) => {
    return { type: DASHBOARD.GET_TRANSACTIONS_GRAPH_DATA_SUCCESS, payload: data }
}


export const getActiveCampaignMapData = (data) => {
    return { type: DASHBOARD.GET_ACTIVE_CAMPAIGNS_MAP_DATA, payload: data }
}
export const getActiveCampaignMapDataSuccess = (data) => {
    return { type: DASHBOARD.GET_ACTIVE_CAMPAIGNS_MAP_DATA_SUCCESS, payload: data }
}


export const getFailedUrlsData = (data) => {
    return { type: DASHBOARD.GET_FAILED_URLS_DATA, payload: data }
}
export const getFailedUrlsDataSuccess = (data) => {
    return { type: DASHBOARD.GET_FAILED_URLS_DATA_SUCCESS, payload: data }
}

export const saveDashboardWidget = (data) => {
    return { type: DASHBOARD.SAVE_DASHBOARD_WIDGET, payload: data }
}
export const saveDashboardWidgetSuccess = (data) => {
    return { type: DASHBOARD.SAVE_DASHBOARD_WIDGET_SUCCESS, payload: data }
}
export const getDashboardWidget = (data) => {
    return { type: DASHBOARD.GET_DASHBOARD_WIDGET, payload: data }
}







